import * as Sentry from '@sentry/vue'

const lastReportedActiveByCode = new Map<string, boolean>()

/**
 * One breadcrumb per fault episode (rising edge). Filter in Sentry: category `player_diagnostics_fault`.
 */
export function reportPlayerDiagnosticsFaultToSentry(code: string, detailMs: number): void {
  if (code === '') {
    return
  }
  if (lastReportedActiveByCode.get(code) === true) {
    return
  }
  lastReportedActiveByCode.set(code, true)
  try {
    Sentry.addBreadcrumb({
      category: 'player_diagnostics_fault',
      message: `player_diagnostics_fault_${code}`,
      level: 'warning',
      data: {
        code,
        detailMs
      }
    })
  }
  catch {
    /* Sentry not initialized or unavailable */
  }
}

export function clearPlayerDiagnosticsFaultSentryDedupe(code: string): void {
  if (code === '') {
    return
  }
  lastReportedActiveByCode.set(code, false)
}

/** Test-only reset of dedupe state. */
export function resetPlayerDiagnosticsFaultSentryDedupeForTests(): void {
  lastReportedActiveByCode.clear()
}
